import { FC, ReactNode } from 'react';
import Collapsible, { CollapsibleProps } from 'react-collapsible';

import { transformEaseFunction } from '../styles';
import { AccordionTrigger, ArrowIcon, IconContainer } from './Accordion.styled';

interface AccordionProps {
  children?: ReactNode;
  itemKey: string;
  triggerElement: CollapsibleProps['trigger'];
  onTrigger: CollapsibleProps['handleTriggerClick'];
  open?: CollapsibleProps['open'];
  noIcon?: boolean;
  tabIndex?: number;
}

export const Accordion: FC<AccordionProps> = ({
  children,
  itemKey,
  triggerElement,
  onTrigger,
  open = false,
  noIcon = false,
  tabIndex,
}) => (
  <Collapsible
    accordionPosition={itemKey}
    easing={transformEaseFunction}
    handleTriggerClick={onTrigger}
    open={open}
    transitionTime={300}
    trigger={
      <AccordionTrigger
        aria-controls={`${itemKey}-content`}
        aria-expanded={open}
        aria-haspopup="true"
        data-testid="accordion-trigger"
        id={`${itemKey}-header`}
        tabIndex={tabIndex}
      >
        {triggerElement}
        {!noIcon && (
          <IconContainer $open={open} data-testid="accordion-icon">
            <ArrowIcon name="chevron_down" />
          </IconContainer>
        )}
      </AccordionTrigger>
    }
  >
    {open ? children : null}
  </Collapsible>
);
